import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useState } from 'react';
import { createContext, useContextSelector } from 'use-context-selector/selectContext';
/** Visibility-only context — only TaskDrawer subscribes; route tree stays outside. */ const TaskPaneVisibilityContext = createContext(false);
/** Actions context — setVisibility is stable; route tree uses this to open drawer. */ const TaskPaneActionsContext = createContext(null);
const noop = (_v)=>{};
export const useTaskDrawerContext = ()=>{
    const visibility = useContextSelector(TaskPaneVisibilityContext, (v)=>v);
    const setVisibility = useContextSelector(TaskPaneActionsContext, (s)=>s);
    return {
        visibility,
        setVisibility: setVisibility !== null && setVisibility !== void 0 ? setVisibility : noop
    };
};
/** Use only setVisibility — does NOT re-render when visibility changes. */ export const useTaskDrawerSetVisibility = ()=>{
    const setVisibility = useContextSelector(TaskPaneActionsContext, (s)=>s);
    return setVisibility !== null && setVisibility !== void 0 ? setVisibility : noop;
};
const StableChildren = /*#__PURE__*/ React.memo(function StableChildren({ children }) {
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
}, (prev, next)=>prev.children === next.children);
StableChildren.displayName = 'TaskPaneStableChildren';
export const TaskPaneContextProvider = ({ children })=>{
    const [visibility, setVisibility] = useState(false);
    const setVisibilityStable = useCallback((v)=>{
        setVisibility(v);
    }, []);
    return /*#__PURE__*/ _jsx(TaskPaneVisibilityContext.Provider, {
        value: visibility,
        children: /*#__PURE__*/ _jsx(TaskPaneActionsContext.Provider, {
            value: setVisibilityStable,
            children: /*#__PURE__*/ _jsx(StableChildren, {
                children: children
            })
        })
    });
};
